var map = {
	"./template.bet777": 1946,
	"./template.bet777.tsx": 1946,
	"./template.betgalaxy": 1947,
	"./template.betgalaxy.tsx": 1947,
	"./template.betprofessor": 1948,
	"./template.betprofessor.tsx": 1948,
	"./template.chromabet": 1949,
	"./template.chromabet.tsx": 1949,
	"./template.default": 340,
	"./template.default.tsx": 340,
	"./template.gigabet": 2128,
	"./template.gigabet.tsx": 2128,
	"./template.pyramidbet": 2015,
	"./template.pyramidbet.tsx": 2015,
	"./template.slambet": 1950,
	"./template.slambet.tsx": 1950,
	"./template.ts": 999
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2795;